import { ref } from 'vue';
import { useToast } from '@travelata-libs/ui-kit';
import { createLead } from '../api';
import { setLeadCookie } from './cookie';
import { LeadBanner, LeadBannerPayload } from '@travelata-libs/ui-shared';


export default function(mobile: boolean) {
    const isSubmitted = ref(false);
    const model = ref({ phone: '', name: '' });
    const loading = ref(false);
    const formRef = ref<{ closeModal: () => {} } | null>(null);
    const { showToast } = useToast();

    const onSubmit = async (data: LeadBannerPayload) => {
        isSubmitted.value = false;
        loading.value = true;
        try {
            await createLead(data);
            setLeadCookie();
            isSubmitted.value = true;
            formRef.value?.closeModal();
        } catch {
            showToast({
                mobile,
                type: 'error',
                title: 'Что-то пошло не так',
                description: 'Заявка не отправлена. Попробуйте ещё раз.'
            })
        } finally {
            loading.value = false;
        }
    };

    return {
        onSubmit,
        isSubmitted,
        model,
        formRef,
        loading,
    }
}